import { ViewModes } from "./types";

export const useViewMode = (viewMode: ViewModes) => ({
  isSingleViewMode: viewMode === "single",
  isMultipleViewMode: viewMode === "multiple",
});
